const PaymentDate = require('./PaymentDate');
const DestinationBankAccount = require('./DestinationBankAccount');
const Transfer = require('./Transfer');

class Validation {
  constructor(data) {
    this._transfer = Object.assign({}, data.transfer);
    this._config = data.config || {};
  }

  validate() {
    let validationErrors = [];

    const paymentDate = new PaymentDate({
      transfer: this._transfer
    }).validate();

    if (!paymentDate.isValid) {
      validationErrors.push(paymentDate);
    }

    const dba = new DestinationBankAccount({
      transfer: this._transfer,
      config: this._config
    }).validate();

    if (!dba.isValid) {
      validationErrors.push(dba);
    }

    const transfer = new Transfer({
      transfer: this._transfer
    }).validate();

    if (!transfer.isValid) {
      validationErrors.push(transfer);
    }

    return validationErrors;
  }
}

module.exports = Validation;
